import angular from 'angular';

// app custom filters
import officeName from './office_name';

// application services
export default angular
  .module('app.filters', [])
  .filter({officeName})
  .name;



// WEBPACK FOOTER //
// ./client/app/filters/filters.js